var AdPosition = require('./constants/adPosition')
var Adapter = require('./constants/adapter')
var ManifestError = require('./constants/adPosition')
var Service = require('./constants/service')
var WillSendEvent = require('./constants/willSendEvent')
/**
 * This static class englobes youbora constants.
 *
 * @class
 * @static
 * @memberof youbora
 */
var Constants = {
  AdPosition: AdPosition,
  ManifestError: ManifestError,
  Service: Service,
  WillSendEvent: WillSendEvent,
  Adapter: Adapter
}

module.exports = Constants
